// @ts-nocheck
import * as React from "react";
import * as ReactDOM from "react-dom";
import Router from "./Routes/routes";
import "../../static/styles.css";
import "./index.css";
import ConfigureStore from "./configureStore";

export const {store, persistor} = ConfigureStore();
const rootEl = document.getElementById("root");


ReactDOM.render(
    <Router store={store} persistor={persistor}/>,
    document.getElementById("root") as HTMLElement
);



